<template>
  <div>
    <card-toolbar
      icon="format_align_left"
      :title="$tc('log')"
    >
      <template #actions>
        <v-switch :label="$tc('log_cache')" @click.stop="showActivateConfirm = true" v-model="logCacheState" left color="green" class="ma-0 pa-0 mt-4" />
      </template>
    </card-toolbar>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row no-gutters class="pa-6">
        <v-col cols="12">
          <div>
            {{ $tc('log_size') }}: {{ this.logSize }} bytes ({{ this.$options.filters.prettyBytes(this.logSize) }})
          </div>
        </v-col>
        <v-col cols="12">
          <v-switch color="green" :label="`${$tc('retrieve_zip')}`" v-model="zip" />
        </v-col>
        <v-col cols="12">
          <v-btn id="HsmLogPage_retrieve" class="mr-2" dark color="info" @click="downloadLog()">
            {{ buttonRetrieve }}
          </v-btn>
          <v-btn id="HsmLogPage_clearLog" dark color="error" @click="showClearConfirm = true">
            {{ $t('clear_log') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <iframe style="display:none" name="hidden-form" id="hidden-form" />

    <confirm-modal
      :open="showClearConfirm"
      :title="clearLogConfirmTitle"
      :message="clearLogConfirmMessage"
      :positive-btn-title="$t('reset')"
      @negative="showClearConfirm = false"
      @positive="confirmClearWithSuccess"
    />
    <confirm-modal
      :open="showActivateConfirm"
      :title="logCacheConfirmTitle"
      :message="logCacheConfirmMessage"
      :positive-btn-title="$t('confirm')"
      @negative="showActivateConfirm = false"
      @positive="confirmWithSuccess"
    />
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
import ConfirmModal from '@/components/ConfirmModal.vue'

export default {
  components: {
    ConfirmModal,
    CardToolbar
  },
  data: function () {
    return {
      zip: false,
      log_oem: false,
      showActivateConfirm: false,
      showClearConfirm: false
    }
  },
  beforeCreate: async function () {
    await this.$store.dispatch('hsm/getLogSize')
    await this.$store.dispatch('hsm/getLogCacheState')
  },
  created: async function () {
    document.addEventListener('keydown', this.press)
  },
  destroyed () {
    // console.log('destroyed')
    document.removeEventListener('keydown', this.press)
  },
  computed: {
    clearLogConfirmTitle () {
      return this.$t('clear_log')
    },
    clearLogConfirmMessage () {
      return this.$t('clear_log_confirm_message')
    },
    logCacheConfirmTitle () {
      return this.logCacheState ? this.$t('deactivate_log_title') : this.$t('activate_log_title')
    },
    logCacheConfirmMessage () {
      return this.logCacheState ? this.$t('deactivate_log_message') : this.$t('activate_log_message')
    },
    buttonRetrieve: function () {
      return this.log_oem ? this.$t('retrieve-oem') : this.$t('retrieve_log')
    },
    logSize () {
      return this.$store.state.hsm.logSize
    },
    logCacheState () {
      return this.$store.state.hsm.logCacheState === 11
    }
  },
  methods: {
    // CLEAR
    async confirmClearWithSuccess () {
      this.clearLog()
    },
    clearLog () {
      Promise.allSettled([
        this.$store.dispatch('hsm/truncateLog'),
        this.$store.dispatch('hsm/getLogSize')
      ])
        .then(() => {
          this.$notify.success({})
          this.showClearConfirm = !this.showClearConfirm
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    // CACHE
    confirmWithSuccess () {
      this.$store
        .dispatch('hsm/setLogCache', { body: { enabled: !this.logCacheState ? 1 : 2 } })
        .then(() => {
          this.showActivateConfirm = false
          this.$notify.success({})
        })
        .catch(err => {
          this.showActivateConfirm = false
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
        .finally(() => {
          this.$store.dispatch('hsm/getLogCacheState')
        })
    },
    async downloadLog () {
      const GET_LOG_START_FULL = 0x00000000
      const GET_LOG_END_FULL = 0x00000000

      // set both to get full compressed log (pkzip format);
      const GET_ZLOG_START_FULL = GET_LOG_START_FULL
      const GET_ZLOG_END_FULL = 0xffffffff

      // set both to get full compressed OEM log (pkzip format)
      const GET_OEM_ZLOG_START_FULL = GET_LOG_START_FULL
      const GET_OEM_ZLOG_END_FULL = GET_ZLOG_END_FULL - 1

      this.$store.dispatch(
        'hsm/getLogSubmit',
        this.log_oem
          ? { start: GET_OEM_ZLOG_START_FULL, end: GET_OEM_ZLOG_END_FULL }
          : this.zip
            ? { start: GET_ZLOG_START_FULL, end: GET_ZLOG_END_FULL }
            : { start: GET_LOG_START_FULL, end: GET_LOG_END_FULL }
      )
    },
    press (event) {
      if (event.which === 119) {
        this.log_oem = !this.log_oem
      }
    }
  }
}
</script>
